<template>
  <div id="app">
    <LeftNav :toglmenu="toglLeftMenu" :sosmed="sosmed"></LeftNav>
    <div id="tgh-content" :class="(this.$store.state.fullScreen ? 'tgh-full' : '')">
      <transition name="custom-classes-transition"
        :enter-active-class="animIn"
        :leave-active-class="animOut">
        <router-view/>
      </transition>
    </div>
    <RightNav :sosmed="sosmed"></RightNav>
  </div>
</template>

<script>
import {apiUrl} from './config'
import axios from 'axios'
import LeftNav from '@/components/LeftNav.vue'
import RightNav from '@/components/RightNav.vue'

export default {
  name: 'App',
  data() {
    return {
      animIn : 'animated fadeIn',
      animOut : 'animated fadeOut',
      toglLeftMenu : 'hide',
      sosmed : []
    }
  },
  components: {
    LeftNav,
    RightNav
  },
  methods : {
    toglMenu() {
      if(this.toglLeftMenu == 'hide'){
        this.toglLeftMenu = 'show'
      } else {
        this.toglLeftMenu = 'hide'
      }
      console.log(this.toglLeftMenu)
    },
    getSosmed() {
      let vm = this
      let url = apiUrl+'/home/sosmed'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.sosmed = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      if(toDepth != fromDepth){
        this.animIn = toDepth < fromDepth ? 'animated bounceInDown' : 'animated bounceInUp'
        this.animOut = toDepth < fromDepth ? 'animated bounceOutDown' : 'animated bounceOutUp'
      } else {
        this.animIn = 'animated fadeIn'
        this.animOut = 'animated fadeOut'
      }
    }
  },
  mounted() {
    this.getSosmed()
  }
}
</script>
